"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Onboarding = void 0;
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_modal_1 = __importDefault(require("react-native-modal"));
const native_1 = require("styled-components/native");
const Page_1 = require("../Page/Page");
const Dots_1 = require("../Dots/Dots");
const BottomButton_1 = require("./BottomButton/BottomButton");
const S = __importStar(require("./Onboarding.styles"));
const isAndroidRTL = react_native_1.I18nManager.isRTL && react_native_1.Platform.OS === 'android';
exports.Onboarding = ({ data, onClose, isVisible, animationInProp = 'slideInUp', animationInTimingProp = 1, animationOutProp = 'slideOutDown', animationOutTimingProp = 1, activeDotColor, inActiveDotColor, enabledDotPress, firstButtonTitle, secondButtonTitle, onPressSecondButton, style, }) => {
    const flatList = react_1.useRef(null);
    const [actualWidth, setActualWidth] = react_1.useState(0);
    const [actualHeight, setActualHeight] = react_1.useState(0);
    const [activeIndex, setActiveIndex] = react_1.useState(0);
    const renderItem = ({ item }) => {
        return (react_1.default.createElement(react_native_1.View, { style: { width: actualWidth } },
            react_1.default.createElement(Page_1.Page, { item: item })));
    };
    const rtlSafeIndex = (i) => (isAndroidRTL ? data.length - 1 - i : i);
    const goToSlide = (pageNum) => {
        setActiveIndex(pageNum);
        if (flatList.current) {
            flatList.current.scrollToOffset({
                offset: rtlSafeIndex(pageNum) * actualWidth,
            });
        }
    };
    const onLayout = ({ nativeEvent }) => {
        const { width, height } = nativeEvent.layout;
        if (width !== actualWidth || height !== actualHeight) {
            setActualWidth(width);
            setActualHeight(height);
        }
    };
    const onMomentumScrollEnd = (e) => {
        const offset = e.nativeEvent.contentOffset.x;
        const newIndex = rtlSafeIndex(Math.round(offset / actualWidth));
        if (newIndex === activeIndex) {
            return;
        }
        setActiveIndex(newIndex);
    };
    const scrollX = react_1.default.useRef(new react_native_1.Animated.Value(0)).current;
    const renderPagination = () => {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            data.length > 1 ? (react_1.default.createElement(Dots_1.SlidingDots, { count: data.length, enabledDotPress: enabledDotPress, onDotPress: (index) => goToSlide(index), activeColor: activeDotColor, inActiveColor: inActiveDotColor, width: actualWidth, scrollX: scrollX })) : (react_1.default.createElement(S.EmptyContainer, null)),
            react_1.default.createElement(BottomButton_1.BottomButton, { activeIndex: activeIndex, lastIndex: data.length - 1, onPressFirstButton: onClose, onPressSecondButton: () => onPressSecondButton
                    ? onPressSecondButton()
                    : goToSlide(activeIndex + 1), firstButtonTitle: firstButtonTitle, secondButtonTitle: secondButtonTitle, width: actualWidth, scrollX: scrollX })));
    };
    const theme = native_1.useTheme();
    return (react_1.default.createElement(react_native_modal_1.default, { isVisible: isVisible, backdropColor: theme.bpCore.colors.text, backdropOpacity: 0.5, animationIn: animationInProp, animationInTiming: animationInTimingProp, animationOut: animationOutProp, animationOutTiming: animationOutTimingProp, useNativeDriver: true, style: [
            style ? { marginHorizontal: 24, ...style } : { marginHorizontal: 24 },
            {
                shadowColor: theme.bpCore.colors.black,
                shadowOffset: { width: 0, height: 2 },
                shadowOpacity: 0.8,
                shadowRadius: 2,
            },
        ] },
        react_1.default.createElement(S.MainContainer, null,
            react_1.default.createElement(S.FlatList, { testID: "onboarding_pages", data: data, renderItem: renderItem, horizontal: true, pagingEnabled: true, keyExtractor: (_, index) => index.toString(), ref: flatList, showsHorizontalScrollIndicator: false, initialNumToRender: 1, bounces: false, onMomentumScrollEnd: onMomentumScrollEnd, extraData: actualWidth, onLayout: onLayout, onScroll: react_native_1.Animated.event([{ nativeEvent: { contentOffset: { x: scrollX } } }], {
                    useNativeDriver: false,
                }) }),
            renderPagination())));
};
